import log from 'loglevel';
import metaData from '../data/metaData';

const env = metaData.environment || "dev";
console.log(env)

// Decide logging level
// There are 5 levels, from lowest to highest: trace debug info warn error
// e.g., trace can view: trace debug info warn error
// e.g., info can view: info warn error

if (["dev", "uat"].includes(env)) {
  // Development and UAT use trace level
  log.setLevel("TRACE");
} else {
  // Default and production use warn level
  log.setLevel("WARN");
}

export default log;